export const ANSWERS = ['юниор', 'бонус', 'навык', 'акция', 'отдел'];
export const TRIES_AMOUNT = 6;
export const CELLS_AMOUNT = 5;